import type { CaptureSequence } from '../types';

/** User-facing view names for self-assessment (internal CaptureSequence keys unchanged). */
export const LAYMAN_VIEW_LABELS: Record<CaptureSequence, string> = {
  Anterior: 'Front side',
  Posterior: 'Back side',
  Left: 'Left side',
  Right: 'Right side',
};

export function getLaymanViewLabel(view: CaptureSequence): string {
  return LAYMAN_VIEW_LABELS[view];
}

/** Plain-language report panel titles (self-assessment / layman mode). */
export function getLaymanViewReportTitle(view: CaptureSequence): string {
  switch (view) {
    case 'Anterior':
      return 'Front and back measurements';
    case 'Posterior':
      return 'Back measurements';
    case 'Left':
      return 'Left side measurements';
    case 'Right':
      return 'Right side measurements';
    default:
      return 'View measurements';
  }
}
